export const FIELDS = {
    COUNTRY: "country-label",
    CITY: "city-label"
}